export const YUHS_DOCTORS = [
  {
    i: "yuhs-0001",
    hid: "yuhs",
    n: "강민유",
    de: "이식외과",
    s: ["장기이식(신장)", "혈액형 부적합 신장이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0002",
    hid: "yuhs",
    n: "강병철",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0003",
    hid: "yuhs",
    n: "강상욱",
    de: "갑상선내분비외과",
    s: ["갑상선암", "부신(내분비 내과 경유)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0004",
    hid: "yuhs",
    n: "강석구",
    de: "신경외과",
    s: ["뇌종양(교모세포종/신경교종/뇌전이암/수막종/기타 뇌종양)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0005",
    hid: "yuhs",
    n: "강순현",
    de: "통합내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0006",
    hid: "yuhs",
    n: "강승연",
    de: "대장항문외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0007",
    hid: "yuhs",
    n: "강신욱",
    de: "신장내과",
    s: ["당뇨병성 신증", "만성신부전증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0008",
    hid: "yuhs",
    n: "강영애",
    de: "호흡기내과",
    s: ["폐결핵", "내성결핵"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0009",
    hid: "yuhs",
    n: "강원준",
    de: "핵의학과",
    s: ["갑상선암 수술후 동위원소"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0010",
    hid: "yuhs",
    n: "강은석",
    de: "내분비내과",
    s: ["당뇨병전단계", "당뇨병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0011",
    hid: "yuhs",
    n: "강지인",
    de: "정신건강의학과",
    s: ["정신신체장애", "신경성신체증상"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0012",
    hid: "yuhs",
    n: "강창무",
    de: "간담췌외과",
    s: ["로봇 및 복강경 수술 - 췌장암", "담도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0013",
    hid: "yuhs",
    n: "강표윤",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0014",
    hid: "yuhs",
    n: "강화평",
    de: "소화기내과",
    s: ["췌장암", "담도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0015",
    hid: "yuhs",
    n: "강희택",
    de: "가정의학과",
    s: ["장기 암생존자", "암성통증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0016",
    hid: "yuhs",
    n: "고병휘",
    de: "신장내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0017",
    hid: "yuhs",
    n: "고서희",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0018",
    hid: "yuhs",
    n: "고예은",
    de: "신장내과",
    s: ["급성신부전", "만성신부전"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0019",
    hid: "yuhs",
    n: "고윤우",
    de: "이비인후과",
    s: ["두경부암 로봇수술", "갑상선암 로봇수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0020",
    hid: "yuhs",
    n: "고지영",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0021",
    hid: "yuhs",
    n: "고희병",
    de: "신장내과",
    s: ["(월 오전 )신장이식", "신장이식클리닉 (목"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0022",
    hid: "yuhs",
    n: "곽영란",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0023",
    hid: "yuhs",
    n: "곽진영",
    de: "영상의학과",
    s: ["갑상선 병변 진단", "초음파"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0024",
    hid: "yuhs",
    n: "구남수",
    de: "감염내과",
    s: ["감염질환", "발열질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0025",
    hid: "yuhs",
    n: "구본녀",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0026",
    hid: "yuhs",
    n: "구자승",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0027",
    hid: "yuhs",
    n: "구철룡",
    de: "내분비내과",
    s: ["뇌하수체 종양", "말단비대증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0028",
    hid: "yuhs",
    n: "국혜원",
    de: "혈액내과",
    s: ["림프종", "다발골수종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0029",
    hid: "yuhs",
    n: "권만재",
    de: "정신건강의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0030",
    hid: "yuhs",
    n: "권순성",
    de: "진단검사의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0031",
    hid: "yuhs",
    n: "권유진",
    de: "가정의학과",
    s: ["건강증진(면역·노화관리)", "비만"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0032",
    hid: "yuhs",
    n: "권자영",
    de: "산부인과",
    s: [
      "고위험 임신",
      "태아기형 초음파 및 치료(태아기형/전치태반- 32주 이내 예약)",
    ],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0033",
    hid: "yuhs",
    n: "권준호",
    de: "영상의학과",
    s: ["말초동맥질환", "정맥질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0034",
    hid: "yuhs",
    n: "권하얀",
    de: "산부인과",
    s: ["고위험 임신", "쌍둥이 임신"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0035",
    hid: "yuhs",
    n: "권혁민",
    de: "정형외과",
    s: ["무릎 인공관절", "고관절 인공관절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0036",
    hid: "yuhs",
    n: "길혜금",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0037",
    hid: "yuhs",
    n: "김가희",
    de: "소화기내과",
    s: ["위암", "식도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0038",
    hid: "yuhs",
    n: "김경민",
    de: "신경과",
    s: ["뇌전증", "뇌전증 수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0039",
    hid: "yuhs",
    n: "김경민",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0040",
    hid: "yuhs",
    n: "김경식",
    de: "간담췌외과",
    s: ["간암", "간문부암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0041",
    hid: "yuhs",
    n: "김관형",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0042",
    hid: "yuhs",
    n: "김광준",
    de: "노년내과",
    s: [
      "노인 및 노년기 질환",
      "노인대사성질환(골다공증/당뇨병/이상지질혈증/대사증후군/동맥경화/지방간)",
    ],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0043",
    hid: "yuhs",
    n: "김근유",
    de: "정신건강의학과",
    s: ["노년기 건망증", "경도인지장애"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0044",
    hid: "yuhs",
    n: "김긍년",
    de: "신경외과",
    s: ["척추신경외과\r\n(척추 및 척수 종양", "경추디스크"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0045",
    hid: "yuhs",
    n: "김기준",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0046",
    hid: "yuhs",
    n: "김기훈",
    de: "신경과",
    s: ["다발성경화증", "시신경척수염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0047",
    hid: "yuhs",
    n: "김나름",
    de: "간담췌외과",
    s: ["간암", "간이식(공여자)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0048",
    hid: "yuhs",
    n: "김나영",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0049",
    hid: "yuhs",
    n: "김남오",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0050",
    hid: "yuhs",
    n: "김다함",
    de: "내분비내과",
    s: ["갑상선암", "갑상선 결절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0051",
    hid: "yuhs",
    n: "김다희",
    de: "이비인후과",
    s: ["두경부암", "갑상선 암(양성종양 포함)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0052",
    hid: "yuhs",
    n: "김대준",
    de: "흉부외과",
    s: ["식도암", "폐암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0053",
    hid: "yuhs",
    n: "김덕기",
    de: "이식외과",
    s: ["간이식", "간기증자 수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0054",
    hid: "yuhs",
    n: "김도영",
    de: "소화기내과",
    s: ["간암", "C형간염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0055",
    hid: "yuhs",
    n: "김도영",
    de: "피부과",
    s: ["베체트병", "구강점막질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0056",
    hid: "yuhs",
    n: "김동석",
    de: "신경외과",
    s: ["소아뇌종양외과", "수두증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0057",
    hid: "yuhs",
    n: "김동윤",
    de: "소화기내과",
    s: ["간암", "간경변"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0058",
    hid: "yuhs",
    n: "김동준",
    de: "영상의학과",
    s: ["뇌혈관 질환 (동맥류", "뇌졸중"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0059",
    hid: "yuhs",
    n: "김만득",
    de: "영상의학과",
    s: [
      "자궁근종  선근증  색전술  골반울혈증후군.  자궁동정맥 기형",
      "자궁내막증(색전술 및 경화술 치료요법 상담)",
    ],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0060",
    hid: "yuhs",
    n: "김명수",
    de: "이식외과",
    s: ["장기이식(간/신장/췌장/소장)\r\n* 목 오후 이식상담"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0061",
    hid: "yuhs",
    n: "김미경",
    de: "일반외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0062",
    hid: "yuhs",
    n: "김미나",
    de: "소화기내과",
    s: ["간암", "간암 중입자치료 상담 클리닉 (금 오후 암병원)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0063",
    hid: "yuhs",
    n: "김미림",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0064",
    hid: "yuhs",
    n: "김미현",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0065",
    hid: "yuhs",
    n: "김민수",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0066",
    hid: "yuhs",
    n: "김민유",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0067",
    hid: "yuhs",
    n: "김민정",
    de: "영상의학과",
    s: ["유방 촬영", "초음파"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0068",
    hid: "yuhs",
    n: "김민정",
    de: "응급의학과",
    s: ["소생의학", "성인응급"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0069",
    hid: "yuhs",
    n: "김민주",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0070",
    hid: "yuhs",
    n: "김범경",
    de: "소화기내과",
    s: ["간암", "만성 바이러스성 간염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0071",
    hid: "yuhs",
    n: "김범석",
    de: "신장내과",
    s: ["만성콩팥병", "신장이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0072",
    hid: "yuhs",
    n: "김병문",
    de: "영상의학과",
    s: ["뇌동맥류", "뇌혈관협착"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0073",
    hid: "yuhs",
    n: "김보경",
    de: "이비인후과",
    s: ["난청(성인", "소아)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0074",
    hid: "yuhs",
    n: "김상겸",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0075",
    hid: "yuhs",
    n: "김상운",
    de: "산부인과",
    s: ["부인암", "내시경/로봇수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0076",
    hid: "yuhs",
    n: "김서라",
    de: "산부인과",
    s: ["고위험 임신", "늦은 나이 임신"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0077",
    hid: "yuhs",
    n: "김성헌",
    de: "이비인후과",
    s: ["어지럼증", "외이기형"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0078",
    hid: "yuhs",
    n: "김성현",
    de: "간담췌외과",
    s: ["췌장암", "담도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0079",
    hid: "yuhs",
    n: "김성환",
    de: "정형외과",
    s: ["무릎관절", "무릎관절염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0080",
    hid: "yuhs",
    n: "김성훈",
    de: "산부인과",
    s: ["부인암", "내시경/로봇수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0081",
    hid: "yuhs",
    n: "김세주",
    de: "정신건강의학과",
    s: ["강박증", "우울증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0082",
    hid: "yuhs",
    n: "김세헌",
    de: "이비인후과",
    s: [
      "두경부암로봇수술",
      "암확진만 가능(내시경 및 영상검사상 의심환자 가능)",
    ],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0083",
    hid: "yuhs",
    n: "김세훈",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0084",
    hid: "yuhs",
    n: "김소라",
    de: "내분비내과",
    s: ["당뇨병", "대사증후군"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0085",
    hid: "yuhs",
    n: "김소연",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0086",
    hid: "yuhs",
    n: "김솔비",
    de: "신경외과",
    s: ["뇌동맥류", "뇌출혈"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0087",
    hid: "yuhs",
    n: "김송이",
    de: "호흡기내과",
    s: ["폐이식", "간질성폐질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0088",
    hid: "yuhs",
    n: "김수진",
    de: "이식외과",
    s: ["동정맥루수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0089",
    hid: "yuhs",
    n: "김수환",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0090",
    hid: "yuhs",
    n: "김승섭",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0091",
    hid: "yuhs",
    n: "김승업",
    de: "소화기내과",
    s: ["바이러스 간염(B형", "C형 간염)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0092",
    hid: "yuhs",
    n: "김승우",
    de: "신경과",
    s: ["중증근무력증", "근위축측삭경화증(루게릭병)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0093",
    hid: "yuhs",
    n: "김승일",
    de: "유방외과",
    s: ["유방암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0094",
    hid: "yuhs",
    n: "김승현",
    de: "정형외과",
    s: ["골종양", "연부조직 종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0095",
    hid: "yuhs",
    n: "김승현",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0096",
    hid: "yuhs",
    n: "김신영",
    de: "진단검사의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0097",
    hid: "yuhs",
    n: "김신형",
    de: "마취통증의학과",
    s: ["1. 척추중재시술 : 척추협착증", "척추디스크질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0098",
    hid: "yuhs",
    n: "김어수",
    de: "정신건강의학과",
    s: ["경도인지장애", "항체 치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0099",
    hid: "yuhs",
    n: "김영대",
    de: "신경과",
    s: ["뇌경색", "뇌혈관협착"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0100",
    hid: "yuhs",
    n: "김영삼",
    de: "호흡기내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0101",
    hid: "yuhs",
    n: "김영진",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0102",
    hid: "yuhs",
    n: "김영태",
    de: "산부인과",
    s: ["부인과 내시경수술", "부인과 로봇수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0103",
    hid: "yuhs",
    n: "김영한",
    de: "산부인과",
    s: ["고위험임신", "태아 기형 초음파"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0104",
    hid: "yuhs",
    n: "김요한",
    de: "성형외과",
    s: ["종괴", "모반"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0105",
    hid: "yuhs",
    n: "김용배",
    de: "신경외과",
    s: ["뇌동맥류", "뇌출혈"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0106",
    hid: "yuhs",
    n: "김용우",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0107",
    hid: "yuhs",
    n: "김유나",
    de: "산부인과",
    s: ["부인암", "항암치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0108",
    hid: "yuhs",
    n: "김유민",
    de: "위장관외과",
    s: ["위암", "위식도경계부암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0109",
    hid: "yuhs",
    n: "김은영",
    de: "호흡기내과",
    s: ["폐암", "폐종양 조직검사"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0110",
    hid: "yuhs",
    n: "김은정",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0111",
    hid: "yuhs",
    n: "김은진",
    de: "갑상선내분비외과",
    s: ["갑상선암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0112",
    hid: "yuhs",
    n: "김의현",
    de: "신경외과",
    s: ["뇌종양", "뇌하수체 종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0113",
    hid: "yuhs",
    n: "김임경",
    de: "일반외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0114",
    hid: "yuhs",
    n: "김장환",
    de: "비뇨의학과",
    s: ["비뇨생식기재건 로봇수술", "전립선비대증(최소침습"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0115",
    hid: "yuhs",
    n: "김정민",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0116",
    hid: "yuhs",
    n: "김정재",
    de: "신경외과",
    s: ["뇌동맥류", "뇌동정맥기형"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0117",
    hid: "yuhs",
    n: "김정호",
    de: "감염내과",
    s: ["HIV 감염. 에이즈", "감염질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0118",
    hid: "yuhs",
    n: "김준형",
    de: "신경외과",
    s: ["뇌정위수술 운동질환(편측성 안면떨림", "본태성 진전"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0119",
    hid: "yuhs",
    n: "김지예",
    de: "유방외과",
    s: ["유방암", "유방 로봇 수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0120",
    hid: "yuhs",
    n: "김지혜",
    de: "가정의학과",
    s: ["건강증진", "노인의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0121",
    hid: "yuhs",
    n: "김지혜",
    de: "통합내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0122",
    hid: "yuhs",
    n: "김지호",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0123",
    hid: "yuhs",
    n: "김지홍",
    de: "일반외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0124",
    hid: "yuhs",
    n: "김지환",
    de: "산부인과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0125",
    hid: "yuhs",
    n: "김지훈",
    de: "소화기내과",
    s: ["췌장암", "담도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0126",
    hid: "yuhs",
    n: "김지훈",
    de: "응급의학과",
    s: ["구급의학", "소생의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0127",
    hid: "yuhs",
    n: "김지희",
    de: "피부과",
    s: ["아토피", "건선"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0128",
    hid: "yuhs",
    n: "김진경",
    de: "갑상선내분비외과",
    s: ["갑상선암갑상선암", "부갑상선질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0129",
    hid: "yuhs",
    n: "김진석",
    de: "혈액내과",
    s: ["악성림프종", "다발골수종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0130",
    hid: "yuhs",
    n: "김진아",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0131",
    hid: "yuhs",
    n: "김진희",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0132",
    hid: "yuhs",
    n: "김찬미",
    de: "호흡기내과",
    s: ["폐암의증", "폐렴"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0133",
    hid: "yuhs",
    n: "김찬형",
    de: "정신건강의학과",
    s: ["강박증", "공황장애"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0134",
    hid: "yuhs",
    n: "김창오",
    de: "노년내과",
    s: ["노년질환", "노인건강상담"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0135",
    hid: "yuhs",
    n: "김창훈",
    de: "이비인후과",
    s: ["비부비동종양", "비부비동염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0136",
    hid: "yuhs",
    n: "김채리",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0137",
    hid: "yuhs",
    n: "김춘옥",
    de: "임상약리학과",
    s: ["초기 임상시험", "약동력학시험"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0138",
    hid: "yuhs",
    n: "김태균",
    de: "피부과",
    s: [
      "건선\r\n농포성건선(전신\r\n손/발바닥)\r\n류마티스성 자가면역 피부질환(피부루푸스/피부근염/피부경화증 등)\r\n소아피부질환(소아면역결핍-피부질환 등)",
    ],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0139",
    hid: "yuhs",
    n: "김태일",
    de: "소화기내과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0140",
    hid: "yuhs",
    n: "김하은",
    de: "흉부외과",
    s: ["폐암", "폐이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0141",
    hid: "yuhs",
    n: "김학선",
    de: "정형외과",
    s: ["척추측만증", "척추협착증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0142",
    hid: "yuhs",
    n: "김현기",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0143",
    hid: "yuhs",
    n: "김현우",
    de: "정형외과",
    s: ["뇌성마비", "손/발 변형"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0144",
    hid: "yuhs",
    n: "김현일",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0145",
    hid: "yuhs",
    n: "김현정",
    de: "이식외과",
    s: ["장기이식(신장)", "혈액형 부적합 신장이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0146",
    hid: "yuhs",
    n: "김현주",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0147",
    hid: "yuhs",
    n: "김형우",
    de: "신장내과",
    s: ["만성콩팥병", "사구체질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0148",
    hid: "yuhs",
    n: "김형일",
    de: "위장관외과",
    s: ["위암", "위점막하종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0149",
    hid: "yuhs",
    n: "김혜경",
    de: "내분비내과",
    s: ["당뇨병", "비만"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0150",
    hid: "yuhs",
    n: "김혜민",
    de: "호흡기내과",
    s: ["폐암의증", "폐렴"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0151",
    hid: "yuhs",
    n: "김혜진",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0152",
    hid: "yuhs",
    n: "김희만",
    de: "소화기내과",
    s: ["소화기암 생존자(위암", "대장암)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0153",
    hid: "yuhs",
    n: "김희연",
    de: "산부인과",
    s: ["난임(가임력 보존", "반복유산)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0154",
    hid: "yuhs",
    n: "김희정",
    de: "마취통증의학과",
    s: ["1. 척추중재시술 : 척추협착증", "척추디스크질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0155",
    hid: "yuhs",
    n: "나민석",
    de: "이비인후과",
    s: ["비부비동염(난치성/재발성)", "비부비동 종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0156",
    hid: "yuhs",
    n: "나성원",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0157",
    hid: "yuhs",
    n: "나한규",
    de: "신경과",
    s: ["파킨슨질환", "루이소체 치매"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0158",
    hid: "yuhs",
    n: "남경선",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0159",
    hid: "yuhs",
    n: "남기헌",
    de: "통합내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0160",
    hid: "yuhs",
    n: "남기현",
    de: "갑상선내분비외과",
    s: ["갑상선암갑상선암", "부갑상선질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0161",
    hid: "yuhs",
    n: "남다정",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0162",
    hid: "yuhs",
    n: "남은지",
    de: "산부인과",
    s: ["부인암", "내시경/로봇수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0163",
    hid: "yuhs",
    n: "남효석",
    de: "신경과",
    s: ["뇌경색", "뇌혈관협착"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0164",
    hid: "yuhs",
    n: "노태훈",
    de: "신경외과",
    s: ["뇌종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0165",
    hid: "yuhs",
    n: "노현정",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0166",
    hid: "yuhs",
    n: "도우성",
    de: "정형외과",
    s: [
      "재발성 어깨탈구(관절경 뼈이식/재건술)",
      "회전근개 파열(부분파열 정밀봉합/광범위 힘줄이식)",
    ],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0167",
    hid: "yuhs",
    n: "류향주",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0168",
    hid: "yuhs",
    n: "명진우",
    de: "응급의학과",
    s: ["성인응급"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0169",
    hid: "yuhs",
    n: "문성환",
    de: "정형외과",
    s: ["척추외과", "척추측만증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0170",
    hid: "yuhs",
    n: "문인석",
    de: "이비인후과",
    s: ["청력개선수술(인공와우", "중이임플란트"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0171",
    hid: "yuhs",
    n: "문주형",
    de: "신경외과",
    s: ["뇌종양", "뇌하수체종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0172",
    hid: "yuhs",
    n: "문한나",
    de: "산부인과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0173",
    hid: "yuhs",
    n: "문현웅",
    de: "신경외과",
    s: ["척추신경외과\r\n(경추질환", "요추질환 등)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0174",
    hid: "yuhs",
    n: "문희선",
    de: "통합내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0175",
    hid: "yuhs",
    n: "민경태",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0176",
    hid: "yuhs",
    n: "민병소",
    de: "대장항문외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0177",
    hid: "yuhs",
    n: "민영기",
    de: "신경과",
    s: [
      "만성염증성탈수초다발신경병 (CIDP)\r\n다초점운동신경병 (MMN)\r\n길랭-바레 증후군 (GBS)\r\n중증근무력증 (MG)\r\n루게릭병 (ALS)\r\n이외 말초신경병",
    ],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0178",
    hid: "yuhs",
    n: "민은기",
    de: "이식외과",
    s: ["간이식", "간암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0179",
    hid: "yuhs",
    n: "박건보",
    de: "정형외과",
    s: ["척추측만증", "뇌성마비"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0180",
    hid: "yuhs",
    n: "박경현",
    de: "정형외과",
    s: ["변형교정 및 골연장술", "뇌성마비"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0181",
    hid: "yuhs",
    n: "박경희",
    de: "알레르기내과",
    s: ["천식", "만성기침(8주이상)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0182",
    hid: "yuhs",
    n: "박관규",
    de: "정형외과",
    s: ["무릎 인공관절외과(전치환술/ 반치환술)", "무릎 퇴행성 관절염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0183",
    hid: "yuhs",
    n: "박광환",
    de: "정형외과",
    s: ["최소침습수술", "무지외반증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0184",
    hid: "yuhs",
    n: "박근영",
    de: "신경외과",
    s: ["뇌동맥류", "뇌동정맥기형"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0185",
    hid: "yuhs",
    n: "박무석",
    de: "호흡기내과",
    s: ["간질성 폐질환", "폐이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0186",
    hid: "yuhs",
    n: "박미숙",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0187",
    hid: "yuhs",
    n: "박민수",
    de: "임상약리학과",
    s: ["초기 임상시험", "약동력학시험"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0188",
    hid: "yuhs",
    n: "박민영",
    de: "대장항문외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0189",
    hid: "yuhs",
    n: "박병조",
    de: "흉부외과",
    s: ["식도암", "폐암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0190",
    hid: "yuhs",
    n: "박상준",
    de: "마취통증의학과",
    s: ["1. 척추중재시술 : 척추협착증", "척추디스크질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0191",
    hid: "yuhs",
    n: "박성현",
    de: "위장관외과",
    s: ["위암", "위점막하종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0192",
    hid: "yuhs",
    n: "박세호",
    de: "유방외과",
    s: ["유방암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0193",
    hid: "yuhs",
    n: "박세희",
    de: "내분비내과",
    s: ["갑상선암", "갑상선 결절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0194",
    hid: "yuhs",
    n: "박수정",
    de: "소화기내과",
    s: ["염증성 장질환 (궤양성 대장염", "크론병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0195",
    hid: "yuhs",
    n: "박수정",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0196",
    hid: "yuhs",
    n: "박슬기",
    de: "일반외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0197",
    hid: "yuhs",
    n: "박승교",
    de: "통합내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0198",
    hid: "yuhs",
    n: "박승우",
    de: "소화기내과",
    s: ["췌장암", "담도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0199",
    hid: "yuhs",
    n: "박시영",
    de: "정형외과",
    s: ["내시경 수술", "척추종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0200",
    hid: "yuhs",
    n: "박신영",
    de: "응급의학과",
    s: ["성인응급"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0201",
    hid: "yuhs",
    n: "박영년",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0202",
    hid: "yuhs",
    n: "박영목",
    de: "호흡기내과",
    s: ["폐결핵", "비결핵항산균"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0203",
    hid: "yuhs",
    n: "박영진",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0204",
    hid: "yuhs",
    n: "박영창",
    de: "정형외과",
    s: ["골반골절", "하지골절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0205",
    hid: "yuhs",
    n: "박용범",
    de: "류마티스내과",
    s: ["류마티스관절염", "강직척추염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0206",
    hid: "yuhs",
    n: "박유석",
    de: "응급의학과",
    s: ["성인응급", "중환자의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0207",
    hid: "yuhs",
    n: "박유진",
    de: "진단검사의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0208",
    hid: "yuhs",
    n: "박윤곤",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0209",
    hid: "yuhs",
    n: "박윤정",
    de: "산부인과",
    s: [
      "부인과양성질환(자궁근종/난소낭종)",
      "부인과 내시경(복강경/자궁경)로봇수술",
    ],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0210",
    hid: "yuhs",
    n: "박윤희",
    de: "진단검사의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0211",
    hid: "yuhs",
    n: "박은경",
    de: "신경외과",
    s: ["소아신경외과", "소아 뇌종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0212",
    hid: "yuhs",
    n: "박은향",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0213",
    hid: "yuhs",
    n: "박인철",
    de: "응급의학과",
    s: ["성인응급", "환경의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0214",
    hid: "yuhs",
    n: "박재준",
    de: "소화기내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0215",
    hid: "yuhs",
    n: "박재현",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0216",
    hid: "yuhs",
    n: "박정엽",
    de: "소화기내과",
    s: ["췌장암", "담도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0217",
    hid: "yuhs",
    n: "박정탁",
    de: "신장내과",
    s: ["만성콩팥병", "사구체질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0218",
    hid: "yuhs",
    n: "박주일",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0219",
    hid: "yuhs",
    n: "박준",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0220",
    hid: "yuhs",
    n: "박준용",
    de: "소화기내과",
    s: ["간암", "간경화"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0221",
    hid: "yuhs",
    n: "박준철",
    de: "소화기내과",
    s: ["위식도역류질환/ 기능성위장장애 등 양성 위장관질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0222",
    hid: "yuhs",
    n: "박중원",
    de: "알레르기내과",
    s: ["천식", "만성기침(8주이상)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0223",
    hid: "yuhs",
    n: "박지수",
    de: "비뇨의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0224",
    hid: "yuhs",
    n: "박지우",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0225",
    hid: "yuhs",
    n: "박지형",
    de: "신경과",
    s: ["어지럼", "만성어지럼"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0226",
    hid: "yuhs",
    n: "박지혜",
    de: "소화기내과",
    s: ["염증성장질환(크론병", "궤양성대장염)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0227",
    hid: "yuhs",
    n: "박진아",
    de: "내분비내과",
    s: ["골다공증", "골무기질대사"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0228",
    hid: "yuhs",
    n: "박진하",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0229",
    hid: "yuhs",
    n: "박진희",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0230",
    hid: "yuhs",
    n: "박찬욱",
    de: "신경과",
    s: ["파킨슨질환", "이상운동질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0231",
    hid: "yuhs",
    n: "박창욱",
    de: "피부과",
    s: ["아토피피부염", "알레르기"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0232",
    hid: "yuhs",
    n: "박채령",
    de: "응급의학과",
    s: ["성인응급"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0233",
    hid: "yuhs",
    n: "박천일",
    de: "정신건강의학과",
    s: ["암환자의 정신건강", "강박장애"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0234",
    hid: "yuhs",
    n: "박철호",
    de: "신장내과",
    s: ["만성콩팥병", "사구체질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0235",
    hid: "yuhs",
    n: "박해정",
    de: "핵의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0236",
    hid: "yuhs",
    n: "박형석",
    de: "유방외과",
    s: ["유방암", "유방암 로봇수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0237",
    hid: "yuhs",
    n: "박희정",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0238",
    hid: "yuhs",
    n: "박희진",
    de: "류마티스내과",
    s: ["류마티스관절염", "강직성척추염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0239",
    hid: "yuhs",
    n: "방승민",
    de: "소화기내과",
    s: ["췌장암", "담도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0240",
    hid: "yuhs",
    n: "배상욱",
    de: "산부인과",
    s: ["요실금", "과민성방광"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0241",
    hid: "yuhs",
    n: "배현우",
    de: "대장항문외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0242",
    hid: "yuhs",
    n: "백송이",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0243",
    hid: "yuhs",
    n: "백우열",
    de: "성형외과",
    s: ["선천성 안면기형", "구순구개열"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0244",
    hid: "yuhs",
    n: "백진경",
    de: "산부인과",
    s: ["부인과양성질환(자궁근종/난소혹/자궁내막증/갱년기상담)", "생식내분비"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0245",
    hid: "yuhs",
    n: "범진호",
    de: "응급의학과",
    s: ["소생의학", "성인응급"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0246",
    hid: "yuhs",
    n: "변효진",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0247",
    hid: "yuhs",
    n: "서니은",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0248",
    hid: "yuhs",
    n: "서배선",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0249",
    hid: "yuhs",
    n: "서석교",
    de: "산부인과",
    s: ["자궁내막증", "폐경 및 골다공증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0250",
    hid: "yuhs",
    n: "서영주",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0251",
    hid: "yuhs",
    n: "서영철",
    de: "성형외과",
    s: ["당뇨발재건", "하지재건"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0252",
    hid: "yuhs",
    n: "서지우",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0253",
    hid: "yuhs",
    n: "성민동",
    de: "호흡기내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0254",
    hid: "yuhs",
    n: "소재은",
    de: "소화기내과",
    s: ["단순 위장관 증상(변비/설사)", "과민성대장증후군"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0255",
    hid: "yuhs",
    n: "손영호",
    de: "신경과",
    s: ["파킨슨병 및 운동장애"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0256",
    hid: "yuhs",
    n: "손진우",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0257",
    hid: "yuhs",
    n: "송승용",
    de: "성형외과",
    s: ["유방 재건 및 유방 성형", "지방이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0258",
    hid: "yuhs",
    n: "송재우",
    de: "진단검사의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0259",
    hid: "yuhs",
    n: "송정식",
    de: "류마티스내과",
    s: ["전신홍반성루프스"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0260",
    hid: "yuhs",
    n: "송종욱",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0261",
    hid: "yuhs",
    n: "송준협",
    de: "진단검사의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0262",
    hid: "yuhs",
    n: "송호택",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0263",
    hid: "yuhs",
    n: "신나영",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0264",
    hid: "yuhs",
    n: "신동아",
    de: "신경외과",
    s: ["척추신경외과\r\n( 최소 침습수술", "통증중재시술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0265",
    hid: "yuhs",
    n: "신동엽",
    de: "내분비내과",
    s: ["갑상선 결절", "갑상선암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0266",
    hid: "yuhs",
    n: "신동현",
    de: "대장항문외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0267",
    hid: "yuhs",
    n: "신동호",
    de: "통합내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0268",
    hid: "yuhs",
    n: "신새암",
    de: "진단검사의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0269",
    hid: "yuhs",
    n: "신서경",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0270",
    hid: "yuhs",
    n: "신성관",
    de: "소화기내과",
    s: ["위암", "식도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0271",
    hid: "yuhs",
    n: "신재원",
    de: "정형외과",
    s: ["경추 질환", "경추 척수증 및 신경근병증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0272",
    hid: "yuhs",
    n: "신하영",
    de: "신경과",
    s: ["중증근무력증", "만성염증탈수초다발신경병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0273",
    hid: "yuhs",
    n: "심규원",
    de: "신경외과",
    s: ["두상교정클리닉", "모야모야병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0274",
    hid: "yuhs",
    n: "심남석",
    de: "이비인후과",
    s: ["두경부암", "갑상선 암(양성종양 포함)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0275",
    hid: "yuhs",
    n: "심동우",
    de: "정형외과",
    s: ["족부 관절과 족부 인대의 질환", "족부 골절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0276",
    hid: "yuhs",
    n: "심재광",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0277",
    hid: "yuhs",
    n: "심지수",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0278",
    hid: "yuhs",
    n: "심효섭",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0279",
    hid: "yuhs",
    n: "안상훈",
    de: "소화기내과",
    s: ["C형 바이러스성 간염", "지방간염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0280",
    hid: "yuhs",
    n: "안석균",
    de: "정신건강의학과",
    s: ["조현병스펙트럼장애(조현병", "정신병적장애"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0281",
    hid: "yuhs",
    n: "안성수",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0282",
    hid: "yuhs",
    n: "안우진",
    de: "소화기내과",
    s: ["염증성장질환(크론병", "궤양성대장염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0283",
    hid: "yuhs",
    n: "안지현",
    de: "유방외과",
    s: ["유방암", "유방암 로봇수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0284",
    hid: "yuhs",
    n: "안진영",
    de: "감염내과",
    s: ["감염질환", "발열질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0285",
    hid: "yuhs",
    n: "안철민",
    de: "통합내과",
    s: ["대동맥질환", "말초동맥질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0286",
    hid: "yuhs",
    n: "양승윤",
    de: "대장항문외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0287",
    hid: "yuhs",
    n: "양영호",
    de: "흉부외과",
    s: ["흉선암(로봇", "단일공 수술)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0288",
    hid: "yuhs",
    n: "양은정",
    de: "성형외과",
    s: ["유방재건 및 유방성형", "흉터성형"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0289",
    hid: "yuhs",
    n: "양재석",
    de: "신장내과",
    s: ["신장이식(당일진료 가능)", "목 오전 신장이식 클리닉"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0290",
    hid: "yuhs",
    n: "양하나",
    de: "통합내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0291",
    hid: "yuhs",
    n: "양현경",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0292",
    hid: "yuhs",
    n: "연정은",
    de: "산부인과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0293",
    hid: "yuhs",
    n: "염준섭",
    de: "감염내과",
    s: [
      "해외여행 후 감염병",
      "모기매개감염병(말라리아/뎅기열/치큰구니아/지카)",
    ],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0294",
    hid: "yuhs",
    n: "예병석",
    de: "신경과",
    s: ["알츠하이머병", "루이소체치매"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0295",
    hid: "yuhs",
    n: "오경택",
    de: "비뇨의학과",
    s: ["배뇨장애", "신경인성방광"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0296",
    hid: "yuhs",
    n: "오병호",
    de: "피부과",
    s: ["피부암", "흑색종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0297",
    hid: "yuhs",
    n: "오상호",
    de: "피부과",
    s: ["백반증", "광(햇빛)과민성질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0298",
    hid: "yuhs",
    n: "오영준",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0299",
    hid: "yuhs",
    n: "오영택",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0300",
    hid: "yuhs",
    n: "오은주",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0301",
    hid: "yuhs",
    n: "오종욱",
    de: "피부과",
    s: ["피부외과", "피부암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0302",
    hid: "yuhs",
    n: "오지웅",
    de: "신경외과",
    s: ["신경중환자 및 중증 두부손상"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0303",
    hid: "yuhs",
    n: "오지은",
    de: "소화기내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0304",
    hid: "yuhs",
    n: "오현경",
    de: "알레르기내과",
    s: ["천식", "만성기침(8주이상)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0305",
    hid: "yuhs",
    n: "용동은",
    de: "진단검사의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0306",
    hid: "yuhs",
    n: "용승현",
    de: "호흡기내과",
    s: ["기관지내시경", "초음파 기관지내시경 및 정밀조직검사"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0307",
    hid: "yuhs",
    n: "우수지",
    de: "소화기내과",
    s: ["단순 위장관 증상(변비/설사)", "과민성대장증후군"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0308",
    hid: "yuhs",
    n: "우아라",
    de: "호흡기내과",
    s: ["간질성폐질환", "폐이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0309",
    hid: "yuhs",
    n: "원동주",
    de: "진단검사의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0310",
    hid: "yuhs",
    n: "원소영",
    de: "신경외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0311",
    hid: "yuhs",
    n: "원종윤",
    de: "영상의학과",
    s: ["간종양 인터벤션치료", "동맥질환 인터벤션치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0312",
    hid: "yuhs",
    n: "유대현",
    de: "성형외과",
    s: ["구순구개열", "선천성 두개안면기형"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0313",
    hid: "yuhs",
    n: "유명원",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0314",
    hid: "yuhs",
    n: "유승연",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0315",
    hid: "yuhs",
    n: "유영진",
    de: "일반외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0316",
    hid: "yuhs",
    n: "유정우",
    de: "신경외과",
    s: ["뇌정위수술 운동질환(편측성 안면떨림", "본태성 진전"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0317",
    hid: "yuhs",
    n: "유태현",
    de: "신장내과",
    s: ["만성콩팥병", "당뇨성 신증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0318",
    hid: "yuhs",
    n: "윤미진",
    de: "핵의학과",
    s: ["치매 PET 건강검진"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0319",
    hid: "yuhs",
    n: "윤보현",
    de: "산부인과",
    s: ["난임(난임 클리닉으로 예약", "전화예약 가능)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0320",
    hid: "yuhs",
    n: "윤선옥",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0321",
    hid: "yuhs",
    n: "윤자경",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0322",
    hid: "yuhs",
    n: "윤정현",
    de: "영상의학과",
    s: ["갑상선 질환 (화 오후)", "유방질환 (월"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0323",
    hid: "yuhs",
    n: "윤종진",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0324",
    hid: "yuhs",
    n: "윤지훈",
    de: "소화기내과",
    s: ["위암", "식도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0325",
    hid: "yuhs",
    n: "윤진우",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0326",
    hid: "yuhs",
    n: "윤진하",
    de: "직업환경의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0327",
    hid: "yuhs",
    n: "윤태환",
    de: "정형외과",
    s: ["회전근개파열", "어깨탈구"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0328",
    hid: "yuhs",
    n: "윤현경",
    de: "응급의학과",
    s: ["성인응급"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0329",
    hid: "yuhs",
    n: "윤혜성",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0330",
    hid: "yuhs",
    n: "음다혜",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0331",
    hid: "yuhs",
    n: "이강영",
    de: "대장항문외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0332",
    hid: "yuhs",
    n: "이건인",
    de: "호흡기내과",
    s: ["기관지내시경", "초음파 기관지내시경 및 정밀조직검사"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0333",
    hid: "yuhs",
    n: "이경원",
    de: "응급의학과",
    s: ["성인응급"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0334",
    hid: "yuhs",
    n: "이규인",
    de: "이비인후과",
    s: ["두경부암", "갑상선 암(양성종양)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0335",
    hid: "yuhs",
    n: "이규호",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0336",
    hid: "yuhs",
    n: "이님",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0337",
    hid: "yuhs",
    n: "이동원",
    de: "성형외과",
    s: ["유방재건", "유방암수술 후 림프부종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0338",
    hid: "yuhs",
    n: "이미정",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0339",
    hid: "yuhs",
    n: "이민영",
    de: "내분비내과",
    s: ["당뇨병", "임신당뇨병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0340",
    hid: "yuhs",
    n: "이반",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0341",
    hid: "yuhs",
    n: "이병완",
    de: "내분비내과",
    s: ["당뇨병전단계", "당뇨병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0342",
    hid: "yuhs",
    n: "이보라",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0343",
    hid: "yuhs",
    n: "이상국",
    de: "진단검사의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0344",
    hid: "yuhs",
    n: "이상길",
    de: "소화기내과",
    s: ["위암", "선종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0345",
    hid: "yuhs",
    n: "이상원",
    de: "류마티스내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0346",
    hid: "yuhs",
    n: "이상훈",
    de: "호흡기내과",
    s: ["기관지내시경", "폐암의증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0347",
    hid: "yuhs",
    n: "이선영",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0348",
    hid: "yuhs",
    n: "이선영",
    de: "통합내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0349",
    hid: "yuhs",
    n: "이성",
    de: "신경외과",
    s: ["척추신경외과\r\n(척추 내시경수술", "척추 협착증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0350",
    hid: "yuhs",
    n: "이성진",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0351",
    hid: "yuhs",
    n: "이수환",
    de: "호흡기내과",
    s: ["중환자치료", "만성폐쇄성폐질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0352",
    hid: "yuhs",
    n: "이승구",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0353",
    hid: "yuhs",
    n: "이승태",
    de: "진단검사의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0354",
    hid: "yuhs",
    n: "이승현",
    de: "내분비내과",
    s: ["갑상선 질환", "골다공증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0355",
    hid: "yuhs",
    n: "이승환",
    de: "비뇨의학과",
    s: ["전립선암", "신장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0356",
    hid: "yuhs",
    n: "이연희",
    de: "신장내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0357",
    hid: "yuhs",
    n: "이영인",
    de: "피부과",
    s: ["흉터", "켈로이드"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0358",
    hid: "yuhs",
    n: "이영한",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0359",
    hid: "yuhs",
    n: "이용섭",
    de: "감염내과",
    s: ["감염질환", "발열질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0360",
    hid: "yuhs",
    n: "이용재",
    de: "산부인과",
    s: ["부인암", "자궁내막상피내종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0361",
    hid: "yuhs",
    n: "이용찬",
    de: "소화기내과",
    s: ["위암", "선종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0362",
    hid: "yuhs",
    n: "이용호",
    de: "내분비내과",
    s: ["당뇨병", "비만"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0363",
    hid: "yuhs",
    n: "이원재",
    de: "성형외과",
    s: ["재건 피판수술", "미용수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0364",
    hid: "yuhs",
    n: "이원태",
    de: "직업환경의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0365",
    hid: "yuhs",
    n: "이유미",
    de: "내분비내과",
    s: ["골다공증", "골연화증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0366",
    hid: "yuhs",
    n: "이은",
    de: "정신건강의학과",
    s: ["<정신건강의학과>", "수면장애"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0367",
    hid: "yuhs",
    n: "이은주",
    de: "류마티스내과",
    s: ["관절염", "결합조직질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0368",
    hid: "yuhs",
    n: "이인국",
    de: "통합내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0369",
    hid: "yuhs",
    n: "이잔디",
    de: "갑상선내분비외과",
    s: ["갑상선암갑상선암", "부갑상선질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0370",
    hid: "yuhs",
    n: "이재근",
    de: "이식외과",
    s: ["간이식", "간절제"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0371",
    hid: "yuhs",
    n: "이재승",
    de: "소화기내과",
    s: ["간암", "바이러스간염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0372",
    hid: "yuhs",
    n: "이재현",
    de: "알레르기내과",
    s: ["천식", "만성기침(8주이상)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0373",
    hid: "yuhs",
    n: "이재훈",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0374",
    hid: "yuhs",
    n: "이정아",
    de: "감염내과",
    s: ["감염질환", "발열질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0375",
    hid: "yuhs",
    n: "이정윤",
    de: "산부인과",
    s: ["부인암", "내시경/로봇수술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0376",
    hid: "yuhs",
    n: "이종수",
    de: "비뇨의학과",
    s: ["전립선암", "신장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0377",
    hid: "yuhs",
    n: "이주용",
    de: "비뇨의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0378",
    hid: "yuhs",
    n: "이주한",
    de: "이식외과",
    s: ["장기이식(신장)", "혈액형 부적합 신장이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0379",
    hid: "yuhs",
    n: "이준호",
    de: "산부인과",
    s: ["고위험임신", "태아기형 초음파 및 태아치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0380",
    hid: "yuhs",
    n: "이지교",
    de: "진단검사의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0381",
    hid: "yuhs",
    n: "이지연",
    de: "일반외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0382",
    hid: "yuhs",
    n: "이지원",
    de: "가정의학과",
    s: ["만성피로", "대사증후군"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0383",
    hid: "yuhs",
    n: "이지현",
    de: "산부인과",
    s: ["부인암", "항암치료"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0384",
    hid: "yuhs",
    n: "이지환",
    de: "응급의학과",
    s: ["소생의학", "성인응급"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0385",
    hid: "yuhs",
    n: "이진구",
    de: "흉부외과",
    s: ["폐이식", "폐암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0386",
    hid: "yuhs",
    n: "이진우",
    de: "정형외과",
    s: ["발 관절염", "발목 관절염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0387",
    hid: "yuhs",
    n: "이찬호",
    de: "호흡기내과",
    s: ["중환자치료", "만성폐쇄성폐질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0388",
    hid: "yuhs",
    n: "이창규",
    de: "신경외과",
    s: ["척추신경외과\r\n( 척추 내시경수술", "척추디스크"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0389",
    hid: "yuhs",
    n: "이창영",
    de: "흉부외과",
    s: ["폐암", "간유리 음영 결절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0390",
    hid: "yuhs",
    n: "이창환",
    de: "직업환경의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0391",
    hid: "yuhs",
    n: "이청",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0392",
    hid: "yuhs",
    n: "이필휴",
    de: "신경과",
    s: ["파킨슨질환", "루이소체 치매"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0393",
    hid: "yuhs",
    n: "이한성",
    de: "노년내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0394",
    hid: "yuhs",
    n: "이혁민",
    de: "진단검사의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0395",
    hid: "yuhs",
    n: "이현지",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0396",
    hid: "yuhs",
    n: "이형우",
    de: "신경과",
    s: ["뇌경색", "뇌혈관협착"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0397",
    hid: "yuhs",
    n: "이형진",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0398",
    hid: "yuhs",
    n: "이혜미",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0399",
    hid: "yuhs",
    n: "이혜원",
    de: "소화기내과",
    s: ["간암 (확진/의증 모두 가능)", "간 경변증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0400",
    hid: "yuhs",
    n: "이혜정",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0401",
    hid: "yuhs",
    n: "이화성",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0402",
    hid: "yuhs",
    n: "이희승",
    de: "소화기내과",
    s: ["췌장암", "담도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0403",
    hid: "yuhs",
    n: "인경",
    de: "이식외과",
    s: ["소아이식클리닉(▲수 오전 어린이병원 1층 u-헬스룸 다학제 진료실)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0404",
    hid: "yuhs",
    n: "임가람",
    de: "소화기내과",
    s: ["췌장암", "담도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0405",
    hid: "yuhs",
    n: "임동진",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0406",
    hid: "yuhs",
    n: "임범진",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0407",
    hid: "yuhs",
    n: "임승현",
    de: "일반외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0408",
    hid: "yuhs",
    n: "임아영",
    de: "호흡기내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0409",
    hid: "yuhs",
    n: "임정훈",
    de: "진단검사의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0410",
    hid: "yuhs",
    n: "임종백",
    de: "진단검사의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0411",
    hid: "yuhs",
    n: "임준석",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0412",
    hid: "yuhs",
    n: "장시환",
    de: "호흡기내과",
    s: ["중환자치료", "만성폐쇄성폐질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0413",
    hid: "yuhs",
    n: "장원석",
    de: "신경외과",
    s: ["감마나이프방사선수술", "심부뇌자극술"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0414",
    hid: "yuhs",
    n: "장원식",
    de: "비뇨의학과",
    s: ["방광암", "전립선암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0415",
    hid: "yuhs",
    n: "장종희",
    de: "신경외과",
    s: ["뇌종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0416",
    hid: "yuhs",
    n: "장지은",
    de: "혈액내과",
    s: ["백혈병", "골수증식종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0417",
    hid: "yuhs",
    n: "장진원",
    de: "소화기내과",
    s: ["위암", "식도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0418",
    hid: "yuhs",
    n: "장철호",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0419",
    hid: "yuhs",
    n: "전병남",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0420",
    hid: "yuhs",
    n: "전승훈",
    de: "응급의학과",
    s: ["성인응급"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0421",
    hid: "yuhs",
    n: "전중현",
    de: "핵의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0422",
    hid: "yuhs",
    n: "정경수",
    de: "호흡기내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0423",
    hid: "yuhs",
    n: "정다현",
    de: "소화기내과",
    s: ["위암", "식도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0424",
    hid: "yuhs",
    n: "정대철",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0425",
    hid: "yuhs",
    n: "정동혁",
    de: "가정의학과",
    s: ["안티에이징", "대사이상 및 만성질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0426",
    hid: "yuhs",
    n: "정문재",
    de: "소화기내과",
    s: ["췌장암", "담도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0427",
    hid: "yuhs",
    n: "정민",
    de: "정형외과",
    s: ["무릎관절", "무릎관절염"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0428",
    hid: "yuhs",
    n: "정민선",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0429",
    hid: "yuhs",
    n: "정보령",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0430",
    hid: "yuhs",
    n: "정석종",
    de: "신경과",
    s: ["파킨슨질환", "루이소체치매"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0431",
    hid: "yuhs",
    n: "정세한",
    de: "정형외과",
    s: ["무릎 관절염", "무릎 전/후방 인대 손상"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0432",
    hid: "yuhs",
    n: "정수진",
    de: "감염내과",
    s: ["장기이식환자 감염", "장기이식환자 예방접종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0433",
    hid: "yuhs",
    n: "정승호",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0434",
    hid: "yuhs",
    n: "정연수",
    de: "산부인과",
    s: ["생식내분비", "부인과 양성 질환(자궁근종/난소낭종/다낭성난소)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0435",
    hid: "yuhs",
    n: "정영철",
    de: "정신건강의학과",
    s: ["알코올중독", "폭식증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0436",
    hid: "yuhs",
    n: "정용은",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0437",
    hid: "yuhs",
    n: "정웅윤",
    de: "갑상선내분비외과",
    s: ["갑상선암", "내분비외과"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0438",
    hid: "yuhs",
    n: "정윤빈",
    de: "일반외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0439",
    hid: "yuhs",
    n: "정윤서",
    de: "진단검사의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0440",
    hid: "yuhs",
    n: "정윤지",
    de: "산부인과",
    s: ["고위험 임신", "태아기형"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0441",
    hid: "yuhs",
    n: "정은주",
    de: "일반외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0442",
    hid: "yuhs",
    n: "정재호",
    de: "위장관외과",
    s: ["위암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0443",
    hid: "yuhs",
    n: "정재홍",
    de: "소화기내과",
    s: ["바이러스성 간염", "지방간 질환 등을 포함한 간수치 상승"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0444",
    hid: "yuhs",
    n: "정종주",
    de: "갑상선내분비외과",
    s: ["갑상선암갑상선암", "부갑상선질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0445",
    hid: "yuhs",
    n: "정준수",
    de: "소화기내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0446",
    hid: "yuhs",
    n: "정준원",
    de: "혈액내과",
    s: ["골수형성이상증후군", "백혈병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0447",
    hid: "yuhs",
    n: "정지예",
    de: "호흡기내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0448",
    hid: "yuhs",
    n: "정지혜",
    de: "류마티스내과",
    s: ["관절염", "결합조직질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0449",
    hid: "yuhs",
    n: "정진세",
    de: "이비인후과",
    s: ["난청(성인/소아)", "유전성 난청"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0450",
    hid: "yuhs",
    n: "정택",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0451",
    hid: "yuhs",
    n: "정해림",
    de: "혈액내과",
    s: ["백혈병", "골수증식종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0452",
    hid: "yuhs",
    n: "정현수",
    de: "응급의학과",
    s: ["성인응급", "재해의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0453",
    hid: "yuhs",
    n: "정현호",
    de: "신경외과",
    s: ["감마나이프", "삼차신경통"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0454",
    hid: "yuhs",
    n: "조민수",
    de: "대장항문외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0455",
    hid: "yuhs",
    n: "조민아",
    de: "위장관외과",
    s: ["위암", "위점막하종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0456",
    hid: "yuhs",
    n: "조수미",
    de: "신경과",
    s: ["뇌전증", "약물난치뇌전증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0457",
    hid: "yuhs",
    n: "조아영",
    de: "소화기내과",
    s: ["단순 위장관 증상(변비/설사)", "과민성대장증후군"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0458",
    hid: "yuhs",
    n: "조영석",
    de: "내분비내과",
    s: ["갑상선결절", "갑상선암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0459",
    hid: "yuhs",
    n: "조용근",
    de: "진단검사의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0460",
    hid: "yuhs",
    n: "조응혁",
    de: "핵의학과",
    s: ["갑상선암 수술후 동위원소"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0461",
    hid: "yuhs",
    n: "조재성",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0462",
    hid: "yuhs",
    n: "조재용",
    de: "정형외과",
    s: ["수부외과", "손목관절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0463",
    hid: "yuhs",
    n: "조준호",
    de: "응급의학과",
    s: ["성인응급"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0464",
    hid: "yuhs",
    n: "조진선",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0465",
    hid: "yuhs",
    n: "조현",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0466",
    hid: "yuhs",
    n: "조현상",
    de: "정신건강의학과",
    s: ["조울증", "우울증"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0467",
    hid: "yuhs",
    n: "조현제",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0468",
    hid: "yuhs",
    n: "조형주",
    de: "이비인후과",
    s: ["수면무호흡", "비부비동종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0469",
    hid: "yuhs",
    n: "조호진",
    de: "핵의학과",
    s: ["갑상선암 수술후 동위원소"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0470",
    hid: "yuhs",
    n: "주동진",
    de: "이식외과",
    s: ["간암", "간경화"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0471",
    hid: "yuhs",
    n: "주민경",
    de: "신경과",
    s: ["난치두통", "만성두통"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0472",
    hid: "yuhs",
    n: "차봉수",
    de: "내분비내과",
    s: ["당뇨병", "임신당뇨병"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0473",
    hid: "yuhs",
    n: "차종태",
    de: "핵의학과",
    s: ["갑상선 암 수술 후 동위원소"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0474",
    hid: "yuhs",
    n: "채동우",
    de: "임상약리학과",
    s: ["임상시험", "적정약물요법"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0475",
    hid: "yuhs",
    n: "채예린",
    de: "소화기내과",
    s: ["위암", "위식도 관련 질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0476",
    hid: "yuhs",
    n: "천세현",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0477",
    hid: "yuhs",
    n: "천유진",
    de: "노년내과",
    s: ["VIP건강검진"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0478",
    hid: "yuhs",
    n: "천재희",
    de: "소화기내과",
    s: ["염증성 장질환(크론병", "궤양성대장염)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0479",
    hid: "yuhs",
    n: "최관웅",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0480",
    hid: "yuhs",
    n: "최기홍",
    de: "이식외과",
    s: ["간암", "간이식(공여자)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0481",
    hid: "yuhs",
    n: "최병욱",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0482",
    hid: "yuhs",
    n: "최서윤",
    de: "소화기내과",
    s: ["대장용종", "진단 및 치료내시경"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0483",
    hid: "yuhs",
    n: "최선아",
    de: "신경외과",
    s: ["뇌종양", "뇌하수체 종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0484",
    hid: "yuhs",
    n: "최세희",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0485",
    hid: "yuhs",
    n: "최승면",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0486",
    hid: "yuhs",
    n: "최승호",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0487",
    hid: "yuhs",
    n: "최아롬",
    de: "응급의학과",
    s: ["성인응급"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0488",
    hid: "yuhs",
    n: "최영득",
    de: "비뇨의학과",
    s: ["로봇수술", "전립선암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0489",
    hid: "yuhs",
    n: "최영식",
    de: "산부인과",
    s: ["배란장애 무월경 폐경", "부인과  로봇 및 내시경"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0490",
    hid: "yuhs",
    n: "최용선",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0491",
    hid: "yuhs",
    n: "최윤락",
    de: "정형외과",
    s: ["수부외과", "손목관절"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0492",
    hid: "yuhs",
    n: "최재영",
    de: "이비인후과",
    s: ["난청(성인", "소아)- 보청기"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0493",
    hid: "yuhs",
    n: "최종락",
    de: "진단검사의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0494",
    hid: "yuhs",
    n: "최준용",
    de: "감염내과",
    s: ["감염질환", "발열질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0495",
    hid: "yuhs",
    n: "최지연",
    de: "통합내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0496",
    hid: "yuhs",
    n: "최진영",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0497",
    hid: "yuhs",
    n: "최태양",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0498",
    hid: "yuhs",
    n: "추현주",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0499",
    hid: "yuhs",
    n: "하영록",
    de: "응급의학과",
    s: ["성인응급"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0500",
    hid: "yuhs",
    n: "하우석",
    de: "신경과",
    s: ["뇌전증", "두통"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0501",
    hid: "yuhs",
    n: "하윤",
    de: "신경외과",
    s: ["척추신경외과\r\n(척추측만증", "척추변형"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0502",
    hid: "yuhs",
    n: "한대훈",
    de: "간담췌외과",
    s: ["간암", "전이성간암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0503",
    hid: "yuhs",
    n: "한석",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0504",
    hid: "yuhs",
    n: "한소정",
    de: "소화기내과",
    s: ["대장암(결장암/직장암)", "대장용종"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0505",
    hid: "yuhs",
    n: "한송이",
    de: "통합내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0506",
    hid: "yuhs",
    n: "한승혁",
    de: "신장내과",
    s: ["(월 오전", "금) 사구체질환 클리닉"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0507",
    hid: "yuhs",
    n: "한웅규",
    de: "비뇨의학과",
    s: ["신장암", "전립선암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0508",
    hid: "yuhs",
    n: "한윤대",
    de: "대장항문외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0509",
    hid: "yuhs",
    n: "한현진",
    de: "신경외과",
    s: ["뇌동맥류", "뇌졸중(출혈성)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0510",
    hid: "yuhs",
    n: "한현호",
    de: "비뇨의학과",
    s: ["전립선암(능동감시", "호르몬/화학/표적/면역 치료)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0511",
    hid: "yuhs",
    n: "함원식",
    de: "비뇨의학과",
    s: ["방광암", "전립선암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0512",
    hid: "yuhs",
    n: "함주현",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0513",
    hid: "yuhs",
    n: "허규하",
    de: "이식외과",
    s: ["장기이식(신장)", "혈액형 부적합 신장이식"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0514",
    hid: "yuhs",
    n: "허선희",
    de: "이식외과",
    s: ["동정맥루", "복부 대동맥류"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0515",
    hid: "yuhs",
    n: "허수진",
    de: "통합내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0516",
    hid: "yuhs",
    n: "허준녕",
    de: "신경과",
    s: ["뇌경색", "뇌혈관협착"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0517",
    hid: "yuhs",
    n: "허지은",
    de: "비뇨의학과",
    s: ["방광암", "신우요관암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0518",
    hid: "yuhs",
    n: "허진",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0519",
    hid: "yuhs",
    n: "허혁",
    de: "대장항문외과",
    s: ["대장암", "직장암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0520",
    hid: "yuhs",
    n: "형우진",
    de: "위장관외과",
    s: ["위암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0521",
    hid: "yuhs",
    n: "홍기호",
    de: "진단검사의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0522",
    hid: "yuhs",
    n: "홍남기",
    de: "내분비내과",
    s: ["골다공증", "골무기질대사"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0523",
    hid: "yuhs",
    n: "홍승수",
    de: "간담췌외과",
    s: ["로봇 및 복강경 수술 - 췌장암", "담도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0524",
    hid: "yuhs",
    n: "홍유진",
    de: "영상의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0525",
    hid: "yuhs",
    n: "홍종원",
    de: "성형외과",
    s: ["안면외상", "안면재건"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0526",
    hid: "yuhs",
    n: "홍주영",
    de: "응급의학과",
    s: ["성인응급"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0527",
    hid: "yuhs",
    n: "홍태희",
    de: "흉부외과",
    s: ["폐암", "폐암 정밀의학"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0528",
    hid: "yuhs",
    n: "홍현준",
    de: "이비인후과",
    s: ["두경부암", "갑상선 암(양성종양 포함)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0529",
    hid: "yuhs",
    n: "홍혜영",
    de: "호흡기내과",
    s: ["만성폐쇄성폐질환"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0530",
    hid: "yuhs",
    n: "황상현",
    de: "핵의학과",
    s: ["갑상선암 수술후 동위원소"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0531",
    hid: "yuhs",
    n: "황신원",
    de: "피부과",
    s: ["건선", "류마티스-피부질환 (피부근염/피부루푸스/전신경화증 등)"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0532",
    hid: "yuhs",
    n: "황윤아",
    de: "내분비내과",
    s: ["뇌하수체 질환", "뇌하수체 호르몬 관련 대사이상"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0533",
    hid: "yuhs",
    n: "황자원",
    de: "위장관외과",
    s: ["위암", "위점막하종양"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0534",
    hid: "yuhs",
    n: "황혜성",
    de: "일반외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "yuhs-0535",
    hid: "yuhs",
    n: "황호경",
    de: "간담췌외과",
    s: ["췌장암", "담도암"],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
];
